import Api from '@/services/api.js';

export default {
  toggleSetting(payload) {
    return Api.put(`user/userSettings/toggleSetting/${payload.field}`, payload);
  },
  updateUserSettings(payload) {
    return Api.put(`user/userSettings`, payload);
  },
  updateSetting(payload) {
    return Api.put(`user/userSettings/updateSetting/${payload.field}`, payload);
  }


}